/**
 * Types that encapsulate patch types from Immer.
 */
import { ImmerBasedPatchTypes, } from "@buildwithflux/models";
import { guid } from "@buildwithflux/shared";
/**
 * Create a new ImmerPatchSequence with proper strategy
 *
 * @param latestPatches - the latest forward/reverse patches, which will _always_ be presented in the resulting ImmerPatchSequence
 * @param patchCreationStrategy - when "create", only use `latestPatches` to create the ImmerPatchSequence and return it; when "combine", will combine the `previousPatch` (if set) as part of the new ImmerPatchSequence
 * @param previousPatch - previous patch that can be used for combining patches, or just to set the previousUid
 */
export function createImmerPatchSequence(latestPatches, patchCreationStrategy, previousPatch) {
    const newPatch = {
        uid: guid(),
        previousUid: previousPatch ? previousPatch.uid : null,
        type: ImmerBasedPatchTypes.patchSequence,
        forward: latestPatches.forward,
        reverse: latestPatches.reverse,
    };
    if (patchCreationStrategy === "combine" && previousPatch) {
        /**
         * Here when combining with last patch, we should unshift both forward and reverse
         * from last patch. See diagram below - we are processing batchedActions resulting
         * in a transition from StateA to StateC, both forward and reverse need to be in
         * order. The order should follow the arrow's direction
         *
         *         -----previousPatch.forward----->         -----newPatch.forward----->
         * StateA                               StateB                              StateC
         *         <----previousPatch.reverse------         <----newPatch.reverse------
         */
        newPatch.forward.unshift(...previousPatch.forward);
        newPatch.reverse.push(...previousPatch.reverse);
        newPatch.previousUid = previousPatch.previousUid;
    }
    return newPatch;
}
/**
 * Compute the number of changes in a patch (or patch set).  This is similar to, but not guaranteed to be,
 * equal to the number of paths that are modified by any given patch.
 */
export function countPatchChanges(patch) {
    return patch.forward.length;
}
/**
 * Get the raw patches from a patch object.
 */
export function getImmerPatches(patch) {
    return { forward: patch.forward, reverse: patch.reverse };
}
//# sourceMappingURL=immerPatchSequence.js.map